<mat-card>
  <h2 translate>operationValidation.title</h2>
  <p translate>operationValidation.subtitle</p>
  <mat-card-content>
    <form [formGroup]="operationValidationForm" (ngSubmit)="consult()">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroChain"
            [cucumberId]="'macroChain'"
            [id]="'macroChainSelect'"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [isRequired]="true"
            [showErrors]="operationValidationForm?.controls?.macroChain?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroOffice"
            [cucumberId]="'macroOffice'"
            [id]="'macroOfficeSelect'"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [isRequired]="true"
            [showErrors]="operationValidationForm?.controls?.macroOffice?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroOfficeUser || isMacroChainUser"></div>
        <!--START DATEPICKERS-->
        <div fxFlex="50" fxFlex.gt-sm="30">
          <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
            <mat-label translate>operationValidation.initialDate</mat-label>
            <input
              #inputInitialDate
              [attr.data-cucumber-id]="'initialDate'"
              id="initialDateInput"
              matInput
              [matDatepicker]="datepickerInitialDate"
              formControlName="initialDate"
              [max]="maxDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
            <mat-datepicker
              [attr.data-cucumber-id]="'initialDatePicker'"
              id="initialDateDatepicker"
              startView="multi-year"
              #datepickerInitialDate
              (monthSelected)="chosenMonthHandler($event, datepickerInitialDate, inputInitialDate)"
              (yearSelected)="chosenYearHandler($event, inputInitialDate)"
            ></mat-datepicker>
            <mat-error *ngIf="operationValidationForm.controls.initialDate.hasError('required')" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="operationValidationForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
            <mat-error *ngIf="operationValidationForm.controls.initialDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <mat-form-field fxFlex="100" appearance="outline" monthYearFullDirective>
            <mat-label translate>operationValidation.finalDate</mat-label>
            <input
              #inputFinalDate
              [attr.data-cucumber-id]="'finalDate'"
              id="finalDateInput"
              matInput
              [matDatepicker]="datepickerFinalDate"
              formControlName="finalDate"
              [min]="minDate"
              [max]="maxFinalDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
            <mat-datepicker
              [attr.data-cucumber-id]="'finalDatePicker'"
              id="finalDateDatepicker"
              startView="multi-year"
              #datepickerFinalDate
              (monthSelected)="chosenMonthHandler($event, datepickerFinalDate, inputFinalDate)"
              (yearSelected)="chosenYearHandler($event, inputFinalDate)"
            ></mat-datepicker>
            <mat-error *ngIf="operationValidationForm.controls.finalDate.hasError('required')" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="operationValidationForm.controls.finalDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="operationValidationForm.controls.finalDate.hasError('matDatepickerMin')" translate
              >field.error.dateFinal</mat-error
            >
            <mat-error *ngIf="operationValidationForm.errors?.dateYearError" translate
              >field.notMoreThanAYear</mat-error
            >
          </mat-form-field>
        </div>
        <div fxFlex="0" fxFlex.gt-sm="40"></div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="office"
            [cucumberId]="'office'"
            [id]="'officeSelect'"
            [dataInput]="officeList"
            [placeholder]="'operationValidation.office'"
            [showErrors]="operationValidationForm?.controls?.office?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="40">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="externalCommercial"
            [cucumberId]="'externalCommercial'"
            [id]="'externalCommercialSelect'"
            [dataInput]="externalCommercialList"
            [placeholder]="'operationValidation.externalCommercial'"
            [showErrors]="operationValidationForm?.controls?.externalCommercial?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="documentSituation"
            [cucumberId]="'documentSituation'"
            [id]="'documentSituationSelect'"
            [dataInput]="docSituationList"
            [placeholder]="'operationValidation.sitDocument'"
            [showErrors]="operationValidationForm?.controls?.documentSituation?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="100">
          <div class="input-fake__wrapper">
            <mat-label class="label-consulta" translate>operationValidation.typeConsultation</mat-label>
          </div>
        </div>

        <div fxFlex="100">
          <mat-list formGroupName="queryTypes" [attr.data-cucumber-id]="'queryTypes'">
            <mat-list-item *ngFor="let element of typeList">
              <mat-checkbox
                fxFlex
                [attr.data-cucumber-id]="'queryTypes-' + element.name"
                id="{{ element.name }}CheckBox"
                [formControlName]="element.name"
                class="checkboxs"
              >
                {{ element.title | translate | uppercase }}
              </mat-checkbox>
            </mat-list-item>
          </mat-list>
        </div>

        <div fxFlex="100">
          <div class="operation-validation__actions">
            <button id="consultBtn" color="accent" type="submit" mat-flat-button [disabled]="disabledSearchButton">
              <mat-label translate>operationValidation.consult</mat-label>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<scf-operation-validation-table *ngFor="let state of operationsByStatus?.elements" [item]="state">
</scf-operation-validation-table>

<mat-card *ngIf="noData">
  <mat-card-content>
    <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
      <mat-label class="panel-request__label-no-operation" translate>operationValidation.noOperations</mat-label>
    </div>
  </mat-card-content>
</mat-card>

<div class="panel_footer__buttons" *ngIf="operationsByStatus?.elements?.length > 0">
  <div fxFlex="100" fxLayoutAlign="end start" fxLayoutGap="16px">
    <button
      id="createAllExcelOperationDetail"
      mat-stroked-button
      color="accent"
      (click)="createAllExcel()"
      [disabled]="excelAndPdfDisabled"
    >
      <mat-icon class="icon-ic_file_download"></mat-icon>
      <span>{{ 'button.exportExcel' | translate | uppercase }}</span>
    </button>
    <button
      id="createAllPdfOperationDetail"
      mat-stroked-button
      color="accent"
      (click)="createAllPdf()"
      [disabled]="excelAndPdfDisabled"
    >
      <mat-icon class="icon-ic_print"></mat-icon>
      <span>{{ 'button.print' | translate | uppercase }}</span>
    </button>
  </div>
</div>
